const DAY_MS = 24 * 60 * 60 * 1000;

function calendarDaySerial(date: Date): number {
  return Math.floor(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / DAY_MS);
}

export function formatMessageDateLabel(date: Date, now: Date = new Date()): string {
  const diffDays = calendarDaySerial(now) - calendarDaySerial(date);
  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";

  const options: Intl.DateTimeFormatOptions =
    date.getFullYear() === now.getFullYear()
      ? { month: "long", day: "numeric" }
      : { month: "long", day: "numeric", year: "numeric" };

  return new Intl.DateTimeFormat("en-US", options).format(date);
}
